import { Steps } from "@aisquare/ui";
import { Section, VariantBlock } from "../lib/Section";

export function StepsDemo() {
  return (
    <Section
      id="steps"
      title="Steps"
      description="Vertical stepper / progress tracker. Renderer for the K2 `steps` block - props are `{ title?, steps: [{id, label, description?, status}], elapsedMs?, receipt? }`."
    >
      <VariantBlock label="In-progress run">
        <div className="w-full max-w-md">
          <Steps
            title="Generating your studio"
            elapsedMs={8200}
            steps={[
              { id: "1", label: "Outline topics", description: "5 topics drafted", status: "completed" },
              { id: "2", label: "Write lessons", description: "Lesson 3 of 5", status: "in_progress" },
              { id: "3", label: "Generate quiz", status: "pending" },
              { id: "4", label: "Publish", status: "pending" },
            ]}
          />
        </div>
      </VariantBlock>

      <VariantBlock label="Mixed terminal states">
        <div className="w-full max-w-md">
          <Steps
            title="Import pipeline"
            steps={[
              { id: "1", label: "Fetch source", status: "completed" },
              { id: "2", label: "Validate schema", status: "failed", description: "2 rows rejected" },
              { id: "3", label: "Load", status: "cancelled" },
            ]}
          />
        </div>
      </VariantBlock>

      <VariantBlock label="Settled (with receipt)">
        <div className="w-full max-w-md">
          <Steps
            title="Deploy"
            steps={[
              { id: "1", label: "Build", status: "completed" },
              { id: "2", label: "Test", status: "completed" },
              { id: "3", label: "Ship", status: "completed" },
            ]}
            receipt={{ outcome: "success", summary: "Deployed to production", identifiers: { release: "v1.4.2" }, at: "2026-06-20T10:30:00Z" }}
          />
        </div>
      </VariantBlock>
    </Section>
  );
}
